export const NeoFieldImage: React.FC<any> = ({data, uid}) => {
  const imagedriver = data[uid] ? data[uid] : "/images/avatar.png";
  return (
    <>
      <img
        className="h-10 w-10 rounded-full border"
        src={imagedriver}
        alt="img"
        onError={event => {
          event.currentTarget.src = "/images/avatar.png";
        }}
      />
    </>
  );
};
